export default __webpack_public_path__ + "static/media/bmi5.01154e4c.jpg";